import ReactMainRoutes from "./routes/RoutesComponent";

function App() {
  return (
    <div className="App">
      <ReactMainRoutes></ReactMainRoutes>
    </div>
  );
}

export default App;

